import axios from "axios";

export async function getProfits({ commit }, payload) {
  try {
    const { data } = await axios.get(
      `profit/${payload.organizationId}/${payload.page}`
    );
    return data;
  } catch (e) {
    return e;
  }
}

export async function getProfitFiltered({ commit }, payload) {
  try {
    const { data } = await axios.post(`profit/get-profit-filtered`, payload);
    return data;
  } catch (e) {
    return e;
  }
}

export async function getProfitVersion({ commit }, payload) {
  try {
    const { data } = await axios.post(
      `profit/profit-versions-detail-by-id`,
      payload
    );
    return data;
  } catch (e) {
    return e;
  }
}

export async function getFieldByCrop({ commit }, payload) {
  try {
    const { data } = await axios.get(
      `soilAreas/get-area-client/${payload.client}/${payload.crop}/${payload.data}`
    );
    return data;
  } catch (e) {
    return e;
  }
}

export async function saveProfit({ commit }, payload) {
  try {
    const { data } = await axios.post(`profit/add`, payload);
    return data;
  } catch (e) {
    return e;
  }
}

export async function saveVersionProfit({ commit }, payload) {
  try {
    const { data } = await axios.post(`profit/add-version`, payload);
    return data;
  } catch (e) {
    return e;
  }
}

export async function acceptProfit({ commit }, payload) {
  try {
    const { data } = await axios.post(`profit/accept`, payload);
    return data;
  } catch (e) {
    return e;
  }
}

export async function getVersionById({ commit }, payload) {
  try {
    const { data } = await axios.post(`profit/profit-by-id`, payload);
    return data;
  } catch (e) {
    return e;
  }
}


export async function getVersionsById({ commit }, payload) {
  try {
    const { data } = await axios.post(`profit/profit-versions-by-id`, payload);
    return data;
  } catch (e) {
    return e;
  }
}


export async function updateProfit({ commit }, payload) {
  try {
    const { data } = await axios.post(`profit/update`, payload);
    return data;
  } catch (e) {
    return e;
  }
}